import { MessageDescriptor } from "@lingui/core";

import { Box, SxProps, Tooltip, TooltipProps } from "@mui/material";

import useTranslatedText from "../../hooks/useTranslatedText";

export interface TooltipWrapperProps extends Omit<TooltipProps, "title"> {
  fullWidth?: boolean;
  /** Condition to show the tooltip wrapper. This prop can be used instead of conditionally passing a title */
  show?: boolean;
  title?: TooltipProps["title"] | MessageDescriptor; // allow title to be optional
  wrapperSx?: SxProps;
}

/**
 * Wrapper component to conditionally render a tooltip; adds a span between the tooltip
 * and the child to ensure that the tooltip has something to attach to
 * */
const TooltipWrapper = ({
  arrow = true,
  children,
  show = true,
  title,
  wrapperSx,
  fullWidth = false,
  ...tooltipProps
}: TooltipWrapperProps) => {
  const { getTranslatedMessage, isValidText } = useTranslatedText();

  if (title && show) {
    return (
      <Tooltip
        arrow={arrow}
        title={isValidText(title) ? getTranslatedMessage(title) : title}
        {...tooltipProps}
      >
        <Box
          component="span"
          sx={{
            display: "flex",
            width: fullWidth ? "100%" : "fit-content",
            maxWidth: "100%",
            ...wrapperSx,
          }}
        >
          {children}
        </Box>
      </Tooltip>
    );
  }

  return children;
};

export default TooltipWrapper;
